import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
import { mapState, mapGetters, useStore } from 'vuex';
import PathItem from '@remote/components/PathItem.vue';
import Icons from '@remote/utils/static-icons';
import Spin from '@remote/components/Spin.vue';
import { createAliasMapFromDownloads, replaceRootAlias } from '@remote/utils';
export default defineComponent({
  components: {
    PathItem,
    Spin
  },
  setup() {
    return {
      store: useStore()
    };
  },
  data() {
    return {
      rootNodes: {},
      showTrees: {
        id: '',
        title: '',
        count: 0,
        icon: '',
        RealPath: '',
        isLoaded: false,
        isWrite: false,
        children: []
      },
      backIndex: [],
      isInRoot: true,
      isLoading: false,
      deleteDeviceFileId: '',
      rootIndex: 0
    };
  },
  computed: {
    ...mapState(['all', 'pathFolderName', 'pathFolderId', 'paths', 'isSupportProxy', 'action', 'historyDownloadPath']),
    ...mapGetters(['runnerPath', 'showPath']),
    currentDownloadPath() {
      var _this$$store$state$de, _this$$store$state;
      let showPath = '';
      if (this.showTrees.RealPath) {
        // 点击后的路径
        showPath = this.showTrees.RealPath;
      } else if (this.pathFolderName) {
        // 手动选择的路径
        showPath = this.pathFolderName;
      } else {
        var _this$runnerPath;
        // 默认路径
        showPath = (_this$runnerPath = this.runnerPath) === null || _this$runnerPath === void 0 ? void 0 : _this$runnerPath.path;
      }
      showPath = replaceRootAlias({
        path: showPath,
        aliasMap: createAliasMapFromDownloads((_this$$store$state$de = (_this$$store$state = this.$store.state) === null || _this$$store$state === void 0 || (_this$$store$state = _this$$store$state.deviceInfoWatchData) === null || _this$$store$state === void 0 ? void 0 : _this$$store$state.downloads) !== null && _this$$store$state$de !== void 0 ? _this$$store$state$de : [])
      });
      return showPath;
    },
    shortCurrentDownloadPath() {
      let showPath = this.currentDownloadPath;
      let pathArr = showPath.split('/');
      pathArr = pathArr.map(item => {
        return item.length > 5 ? `${item.substring(0, 4)}...` : item;
      });
      const showIndex = pathArr.indexOf('迅雷') === -1 ? pathArr.indexOf('迅雷下载') : pathArr.indexOf('迅雷');
      if (showIndex >= 0) {
        if (pathArr.length > 4) {
          return ['...', pathArr[pathArr.length - 3], pathArr[pathArr.length - 2], pathArr[pathArr.length - 1]].join('/');
        }
        const path = ['...', ...pathArr.slice(showIndex)].join('/');
        return path;
      } else {
        if (pathArr.length > 4) {
          return ['...', pathArr[pathArr.length - 3], pathArr[pathArr.length - 2], pathArr[pathArr.length - 1]].join('/');
        }
        const path = ['...', ...pathArr.slice(1)].join('/');
        return path;
      }
    }
  },
  watch: {
    action(val) {
      if (val === 'delete-device') {
        this.deleteDevice();
      }
    },
    showTrees(val) {
      console.log('showTrees changed', val);
    }
  },
  async mounted() {
    this.init();
  },
  methods: {
    handleToast() {
      this.store.commit('toast', this.currentDownloadPath);
    },
    async init() {
      var _this$runnerPath2;
      console.log('this.runnerPath', this.runnerPath);
      const path_split = (((_this$runnerPath2 = this.runnerPath) === null || _this$runnerPath2 === void 0 ? void 0 : _this$runnerPath2.path) || '').split('/');
      const title = path_split[path_split.length - 2];
      const root = await this.loadFunction({
        id: '0'
      });
      const children = root.filter(child => child.isWrite);
      const rootNodes = {
        id: '0',
        title: title,
        count: 10,
        icon: Icons.dir,
        RealPath: '',
        isWrite: false,
        isLoaded: true,
        children
      };
      this.rootNodes = rootNodes;
      this.isInRoot = true;
      this.showTrees = this.rootNodes;
    },
    getUpperPath() {
      if (this.backIndex.length > 0) {
        this.backIndex.pop();
        let showTrees = this.rootNodes.children[this.rootIndex];
        for (let i = 0; i < this.backIndex.length; i++) {
          showTrees = showTrees.children[this.backIndex[i]];
        }
        this.showTrees = showTrees;
      } else {
        this.init();
      }
    },
    goFileIndex() {
      this.showTrees = this.rootNodes.children[this.rootIndex];
      this.backIndex = [];
    },
    async handleDelete(file) {
      this.deleteDeviceFileId = file.id;
      this.store.commit('dialog', {
        show: true,
        title: '确认删除该目录？',
        tip: '',
        okTxt: '确定',
        cancelTxt: '取消',
        cancel: '',
        action: 'delete-device'
      });
    },
    async deleteDevice() {
      this.store.commit('dialog', {
        show: false
      });
      this.isLoading = true;
      try {
        await this.store.dispatch('deleteDeviceDownloadPath', this.deleteDeviceFileId);
        await this.store.dispatch('getDeviceDownloadPath');
        this.isLoading = false;
        this.init();
      } catch (error) {
        this.isLoading = false;
      }
    },
    async handleGetIn(index, isHistory) {
      const showTrees = isHistory ? this.historyDownloadPath[index] : this.showTrees.children[index];
      if (!showTrees.isLoaded) {
        const children = await this.loadFunction(showTrees);
        if (children) {
          showTrees.children = children;
          showTrees.isLoaded = true;
        }
      }
      this.showTrees = showTrees;
      if (this.isInRoot) {
        this.isInRoot = false;
        this.rootIndex = index;
      } else {
        this.backIndex.push(index);
      }
      console.log('this.showTrees', this.showTrees, this.rootNodes);
    },
    async loadFunction(node) {
      this.isLoading = true;
      const data = await this.store.dispatch('getPaths', node.id);
      this.isLoading = false;
      return data ? data.map(v => ({
        id: v.id,
        title: v.name,
        icon: v.icon_link || Icons.dir,
        isLoaded: false,
        RealPath: v.params.RealPath,
        isWrite: v.params.is_write === 'true',
        children: []
      })) : [];
    },
    commitFunction() {
      console.log('this.showTrees', this.showTrees);
      if (this.showTrees.id !== '0') {
        this.store.commit('update', {
          pathFolderId: this.showTrees.id,
          pathFolderName: this.showTrees.RealPath
        });
      } else {
        this.store.commit('update', {
          pathFolderId: '',
          pathFolderName: ''
        });
      }
      this.store.commit('update', {
        rootSplitPath: this.showTrees.RealPath.slice(0, 8)
      });
    },
    closeFrame() {
      this.store.commit('update', {
        visiblePathChoose: false
      });
    },
    okFrame() {
      if (this.showTrees.isWrite) {
        this.commitFunction();
        this.store.commit('update', {
          visiblePathChoose: false
        });
      }
    }
  }
});